import config from 'constants/config'

export const isAgentHubEnabled = config.agentHub?.isEnabled
export const isAgentHubMultiCartItemsEnabled = isAgentHubEnabled && config.UNIVERSAL_CHECKOUT_MULTI_CART_ITEMS_ENABLED
